import React from 'react';

function OrdersAdmin() {
    return (
        <div id="orders-content" className="p-8 bg-cream font-script">
            <div id="orders-stats" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow card-hover">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">Total Orders</p>
                            <p className="text-2xl font-bold text-gray-800">247</p>
                        </div>
                        <i className="fa-solid fa-shopping-cart text-2xl text-custom-green"></i>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow card-hover">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">Pending</p>
                            <p className="text-2xl font-bold text-yellow-600">12</p>
                        </div>
                        <i className="fa-solid fa-clock text-2xl text-yellow-600"></i>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow card-hover">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">Processing</p>
                            <p className="text-2xl font-bold text-blue-600">18</p>
                        </div>
                        <i className="fa-solid fa-cog text-2xl text-blue-600"></i>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow card-hover">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">Shipped</p>
                            <p className="text-2xl font-bold text-green-600">203</p>
                        </div>
                        <i className="fa-solid fa-truck text-2xl text-green-600"></i>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow card-hover">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">Cancelled</p>
                            <p className="text-2xl font-bold text-red-600">14</p>
                        </div>
                        <i className="fa-solid fa-times-circle text-2xl text-red-600"></i>
                    </div>
                </div>
            </div>

            <div id="orders-controls" className="bg-white rounded-lg shadow p-6 mb-8">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
                    <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
                        <div className="relative">
                            <i className="fa-solid fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                            <input type="text" placeholder="Search orders..."
                                   className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent w-full sm:w-64"/>
                        </div>

                        <select
                            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent">
                            <option>All Status</option>
                            <option>Pending</option>
                            <option>Processing</option>
                            <option>Shipped</option>
                            <option>Delivered</option>
                            <option>Cancelled</option>
                        </select>

                        <select
                            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent">
                            <option>Last 30 Days</option>
                            <option>Last 7 Days</option>
                            <option>Today</option>
                            <option>This Month</option>
                            <option>Custom Range</option>
                        </select>
                    </div>

                    <div className="flex space-x-3">
                        <button
                            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 flex items-center">
                            <i className="fa-solid fa-download mr-2"></i>
                            Export
                        </button>
                        <button
                            className="px-4 py-2 bg-custom-green text-white rounded-lg hover:bg-opacity-90 flex items-center">
                            <i className="fa-solid fa-plus mr-2"></i>
                            Manual Order
                        </button>
                    </div>
                </div>
            </div>

            <div id="orders-table" className="bg-white rounded-lg shadow overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead className="bg-gray-50 border-b">
                        <tr>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Order</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Products</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        <tr className="order-row">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div>
                                    <div className="font-medium text-gray-900">#1247</div>
                                    <div className="text-sm text-gray-500">Payment: Stripe</div>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <img
                                        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg"
                                        alt="Customer" className="w-8 h-8 rounded-full mr-3"/>
                                    <div>
                                        <div className="font-medium text-gray-900">John Dimitriou</div>
                                        <div className="text-sm text-gray-500">john.d@email.com</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="text-sm text-gray-900">Classic Round Basket x2</div>
                                <div className="text-sm text-gray-500">2 items</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Dec 14, 2024</div>
                                <div className="text-sm text-gray-500">10:30 AM</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <span className="status-badge status-delivered">Delivered</span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="font-medium text-gray-900">€89.50</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex space-x-2">
                                    <button className="text-custom-green hover:text-opacity-80">
                                        <i className="fa-solid fa-eye"></i>
                                    </button>
                                    <button className="text-blue-600 hover:text-blue-800">
                                        <i className="fa-solid fa-edit"></i>
                                    </button>
                                    <button className="text-red-600 hover:text-red-800">
                                        <i className="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr className="order-row">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div>
                                    <div className="font-medium text-gray-900">#1246</div>
                                    <div className="text-sm text-gray-500">Payment: Stripe</div>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <img
                                        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg"
                                        alt="Customer" className="w-8 h-8 rounded-full mr-3"/>
                                    <div>
                                        <div className="font-medium text-gray-900">Maria Kostas</div>
                                        <div className="text-sm text-gray-500">maria.k@email.com</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="text-sm text-gray-900">Large Laundry Basket x1</div>
                                <div className="text-sm text-gray-500">1 item</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Dec 14, 2024</div>
                                <div className="text-sm text-gray-500">2:15 PM</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <span className="status-badge status-processing">Processing</span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="font-medium text-gray-900">€125.00</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex space-x-2">
                                    <button className="text-custom-green hover:text-opacity-80">
                                        <i className="fa-solid fa-eye"></i>
                                    </button>
                                    <button className="text-blue-600 hover:text-blue-800">
                                        <i className="fa-solid fa-edit"></i>
                                    </button>
                                    <button className="text-red-600 hover:text-red-800">
                                        <i className="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr className="order-row">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div>
                                    <div className="font-medium text-gray-900">#1245</div>
                                    <div className="text-sm text-gray-500">Payment: Stripe</div>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <img
                                        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-8.jpg"
                                        alt="Customer" className="w-8 h-8 rounded-full mr-3"/>
                                    <div>
                                        <div className="font-medium text-gray-900">Nikos Papadopoulos</div>
                                        <div className="text-sm text-gray-500">nikos.p@email.com</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="text-sm text-gray-900">Storage Basket with Lid x1</div>
                                <div className="text-sm text-gray-500">1 item</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Dec 13, 2024</div>
                                <div className="text-sm text-gray-500">11:45 AM</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <span className="status-badge status-shipped">Shipped</span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="font-medium text-gray-900">€67.25</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex space-x-2">
                                    <button className="text-custom-green hover:text-opacity-80">
                                        <i className="fa-solid fa-eye"></i>
                                    </button>
                                    <button className="text-blue-600 hover:text-blue-800">
                                        <i className="fa-solid fa-edit"></i>
                                    </button>
                                    <button className="text-red-600 hover:text-red-800">
                                        <i className="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr className="order-row">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div>
                                    <div className="font-medium text-gray-900">#1244</div>
                                    <div className="text-sm text-gray-500">Payment: Stripe</div>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <img
                                        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-6.jpg"
                                        alt="Customer" className="w-8 h-8 rounded-full mr-3"/>
                                    <div>
                                        <div className="font-medium text-gray-900">Elena Georgiadou</div>
                                        <div className="text-sm text-gray-500">elena.g@email.com</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="text-sm text-gray-900">Picnic Basket x1, Round Basket x1</div>
                                <div className="text-sm text-gray-500">2 items</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Dec 13, 2024</div>
                                <div className="text-sm text-gray-500">9:20 AM</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <span className="status-badge status-pending">Pending</span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="font-medium text-gray-900">€170.00</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex space-x-2">
                                    <button className="text-custom-green hover:text-opacity-80">
                                        <i className="fa-solid fa-eye"></i>
                                    </button>
                                    <button className="text-blue-600 hover:text-blue-800">
                                        <i className="fa-solid fa-edit"></i>
                                    </button>
                                    <button className="text-red-600 hover:text-red-800">
                                        <i className="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr className="order-row">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div>
                                    <div className="font-medium text-gray-900">#1243</div>
                                    <div className="text-sm text-gray-500">Payment: Stripe</div>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <img
                                        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg"
                                        alt="Customer" className="w-8 h-8 rounded-full mr-3"/>
                                    <div>
                                        <div className="font-medium text-gray-900">Dimitris Antoniadis</div>
                                        <div className="text-sm text-gray-500">dimitris.a@email.com</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="text-sm text-gray-900">Classic Round Basket x3</div>
                                <div className="text-sm text-gray-500">3 items</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Dec 12, 2024</div>
                                <div className="text-sm text-gray-500">4:10 PM</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <span className="status-badge status-cancelled">Cancelled</span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="font-medium text-gray-900">€135.00</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex space-x-2">
                                    <button className="text-custom-green hover:text-opacity-80">
                                        <i className="fa-solid fa-eye"></i>
                                    </button>
                                    <button className="text-blue-600 hover:text-blue-800">
                                        <i className="fa-solid fa-edit"></i>
                                    </button>
                                    <button className="text-red-600 hover:text-red-800">
                                        <i className="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div id="pagination" className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t">
                    <div className="flex items-center">
                        <span className="text-sm text-gray-700">
                            Showing <span className="font-medium">1</span> to <span
                            className="font-medium">5</span> of <span className="font-medium">247</span> orders
                        </span>
                    </div>
                    <div className="flex space-x-2">
                        <button
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50"
                            disabled>
                            Previous
                        </button>
                        <button className="px-3 py-1 text-sm bg-custom-green text-white rounded">1</button>
                        <button
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50">2
                        </button>
                        <button
                            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50">3
                        </button>
                        <button className="px-3 py-1 text-sm bg-white border border-gray-300 rounded hover:bg-gray-50">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default OrdersAdmin;